<app-loading-screen 
  #loadingComponent></app-loading-screen>
<div class="app-container" [ngClass]="{'body-loading': isLoading}">
  <app-header></app-header>
  <app-home #home></app-home>
  <app-about #about></app-about>
  <app-services #services></app-services>
  <app-contact #contact></app-contact>
  <app-footer></app-footer>
</div>